//  ==========================================================================
//
//  Research (detail page)
//
//  ==========================================================================
import React, { PureComponent } from 'react';

import { graphql } from 'gatsby';

import { ArticleWrapper } from '../../components';

import { normalizeResearch } from '../../helpers';

export default class Research extends PureComponent {
	constructor(props) {
		super(props);
		this._researchInfo = normalizeResearch(this.props.data.wordsbyCollections);
	}

	render() {
		return (
			<main id="main">
				<ArticleWrapper articleContent={this._researchInfo} />
			</main>
		);
	}
}

export const researchQuery = graphql`
	query ResearchByID($id: Int!) {
		wordsbyCollections(ID: { eq: $id }) {
			...PostFields
			...HeroComponent

			sections
			locations {
				relationshipByID {
					post_title
				}
			}
			project_types {
				relationshipByID {
					post_title
				}
			}
			services {
				relationshipByID {
					post_title
				}
			}

			title_alignment

			...ThumbnailFields

			description
			short_summary
			featured
			byline {
				relationshipByID {
					...PersonFragment
				}
			}
			pdf
			pdfAttachment {
				...WordsbyAttachment
			}
			panels_collection {
				__typename
				... on WordPressAcf_pull_quote {
					text
				}
				... on WordPressAcf_wysiwyg {
					text
				}
				... on WordPressAcf_subhead {
					text
				}
				... on WordPressAcf_video {
					video_id
				}
				... on WordPressAcf_featured_content {
					curated_content {
						relationshipByID {
							...CardComponent
						}
					}
				}
				... on WordPressAcf_image {
					caption
					fileAttachment {
						...WordsbyAttachment
					}
				}
			}
		}
	}
`;
